export const MyTripsIcon = () => {
  return (
    <svg
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <mask
        id="a"
        height="20"
        maskUnits="userSpaceOnUse"
        width="20"
        x="0"
        y="0"
      >
        <path d="m0 0h20v20h-20z" fill="#d9d9d9" />
      </mask>
      <g mask="url(#a)">
        <path
          d="m9.99216 15.9454c-.16458 0-.32298-.0286-.4752-.0856-.15223-.0573-.29674-.1473-.43354-.27l-.98875-.9007c-1.51917-1.3472-2.84528-2.6498-3.97834-3.9079-1.13305-1.25805-1.69958-2.58791-1.69958-3.98957 0-1.09959.37687-2.02028 1.13062-2.76209.75389-.74194 1.68952-1.11291 2.80688-1.11291.64694 0 1.28708.14798 1.92041.44395.6332.29598 1.20834.79917 1.72544 1.50959.5448-.71042 1.1287-1.21361 1.7516-1.50959.6231-.29597 1.2523-.44395 1.8875-.44395 1.1177 0 2.0545.37097 2.8105 1.11291.7558.74181 1.1337 1.6625 1.1337 2.76209 0 1.41777-.5798 2.75965-1.7396 4.02567-1.1597 1.2659-2.4725 2.5538-3.9383 3.8637l-.9969.9088c-.1366.1227-.2824.2127-.4373.27-.155.057-.3147.0856-.47914.0856zm-.50812-9.91336c-.38139-.68694-.84215-1.19736-1.38229-1.53125-.54-.33389-1.1225-.50083-1.7475-.50083-.81542 0-1.495.26389-2.03875.79167-.54361.52777-.81542 1.19715-.81542 2.00812 0 .64945.20861 1.32167.62583 2.01667.41723.695.94098 1.39268 1.57125 2.09288.63028.7005 1.31487 1.3807 2.05376 2.0409.73875.6602 1.43236 1.2789 2.08083 1.8558.04805.0428.10416.0642.16835.0642.0641 0 .1203-.0214.1683-.0642.6485-.5769 1.3421-1.1956 2.0808-1.8558.7389-.6602 1.4235-1.3404 2.0538-2.0409.6303-.7002 1.154-1.39788 1.5712-2.09288.4173-.695.6259-1.36722.6259-2.01667 0-.81097-.2718-1.48035-.8154-2.00812-.5438-.52778-1.2234-.79167-2.0388-.79167-.625 0-1.211.16694-1.7579.50083-.5471.33389-1.0113.84431-1.3927 1.53125-.0428.10681-.111.18348-.2046.23-.0936.04639-.1908.06959-.29166.06959-.10083 0-.20118-.0232-.30104-.06959-.09986-.04652-.17118-.12319-.21396-.23z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
